const singlePage = [
    {
        path: '/login',
        name: 'login-page',
        meta: {
            title: '登录'
        },
        component: () => import('@/pages/login/Login.vue')
    },
    {
        path: '/wechat-jump',
        name: 'wechat-jump',
        meta: {
            title: '微信登录中'
        },
        component: () => import('@/pages/login/WechatLogining.vue')
    },
    {
        path: '/app-download/:type?',
        name: 'app-download',
        meta: {
            title: 'app下载'
        },
        component: () => import('@/pages/login/AppDownload.vue')
    },
    {
        path: '/privacy',
        name: 'privacy',
        meta: {
            title: '隐私政策'
        },
        component: () => import('@/components/privacy/Index'),
    },
];
export default singlePage;


// WEBPACK FOOTER //
// ./src/router/singlePage.js